import * as React from "react";
import API from "../../../vendor/api";
import { connect, Dispatch } from "react-redux";
import { RootState } from "../../../redux/index";

import ChatList from "../../ChatList";
import Tab from "../../../components/Tab";
import ContactList from "../../ContactList";
import Avatar from "../../../components/Avatar";
import { Header, Title } from "../../../components/Header";
import { InvitePatientFields } from "../../../components/Forms/InviteUserForm";
import InviteUserDialog from "../../../components/Dialogs/InviteUserDialog";
import CreateGroupDialog from "../../../components/Dialogs/CreateGroupDialog";

import { selectSidebarView } from "../../../redux/modules/ui/ui";
import { invitePatient, inviteDoctor } from "../../../redux/modules/appContacts/appContacts";
import { setDialogStatus } from "../../../redux/modules/ui/ui";

import SandwichMenu from "../../../components/SandwichMenu";

import { IUser } from "../../../types";

import { createGroup } from "../../../redux/modules/appChats/appChats";

const s = require("./sidebar.scss");

interface ISidebarMainProps {
    user: IUser;
    activeView: string;
    dispatch?: Dispatch<any>;
    isInvitePatientDialogOpen: boolean;
    isInviteDoctorDialogOpen: boolean;
    isCreateGroupDialogOpen: boolean;
    contacts: IUser[];
};

interface ISidebarMainState {
    doctors: IUser[];
};

class SidebarMain extends React.Component<ISidebarMainProps, ISidebarMainState> {
    onTabSelection(tab: string) {
        this.props.dispatch(selectSidebarView(tab));
    }

    onEditProfile() {
        this.props.dispatch(selectSidebarView("editMyProfile"));
    }

    /**
     * Callback functions
     */

    invitePatient(fields: InvitePatientFields) {
        // console.log({fields});
        this.props.dispatch(invitePatient(fields.phone));
        this.closeInvitePatientDialog();
    }

    inviteDoctor(fields: InvitePatientFields) {
        // console.log({fields});
        this.props.dispatch(inviteDoctor(fields.phone));
        this.closeInvitePatientDialog();
    }

    createGroup(checkedContacts: string[], name: string) {
        console.log(checkedContacts, name);
        if (checkedContacts.length < 1) {
            alert("Você não selecionou nenhum médico.");
            return;
        }
        if (name === "") {
            alert("Informe um nome para o grupo.");
            return;
        }

        this.props.dispatch(createGroup(name, checkedContacts));
        this.closeCreateGroupDialog();
    }

    /**
     * Open dialog
     */

    onAddContact() {
        this.props.dispatch(setDialogStatus("invitePatient", true));
    }

    onInviteDoctor() {
        this.props.dispatch(setDialogStatus("inviteDoctor", true));
    }

    openCreateGroupDialog() {
        this.props.dispatch(setDialogStatus("createGroup", true));
    }

    /**
     * Close dialog
     */

    closeInvitePatientDialog() {
        this.props.dispatch(setDialogStatus("invitePatient", false));
    }

    closeInviteDoctorDialog() {
        this.props.dispatch(setDialogStatus("inviteDoctor", false));
    }

    closeCreateGroupDialog() {
        this.props.dispatch(setDialogStatus("createGroup", false));
    }

    /**
     * Getting doctors names
     */

    componentDidMount() {
        API.getAllDoctors({}, 0).then(doctors => {
            this.setState({
                doctors
            });
        });
    }

    render(): JSX.Element {
        const user = this.props.user;
        const is_doctor = this.props.user.is_doctor;

        let options = [
            {
                label: "Editar perfil",
                onClick: this.onEditProfile.bind(this)
            }            
        ];

        if (is_doctor) {
            options = options.concat([
                {
                    label: "Convidar para conversa",
                    onClick: this.onAddContact.bind(this)
                },
                {
                    label: "Criar grupo",
                    onClick: this.openCreateGroupDialog.bind(this)
                }
            ]);
        } else {
            options = options.concat([
                {
                    label: "Convidar médico",
                    onClick: this.onInviteDoctor.bind(this)
                }
            ]);
        }

        return (
            <div className={s.sidebar}>
                <div className={s.headerWrapper}>
                        <div className={s.header}>
                            <div className={s.userInfo}>
                                <Avatar
                                    image={(user.avatar ? user.avatar.small_url : null)}
                                />

                                <Title>{user.name}</Title>
                            </div>

                            <div>     
                                <SandwichMenu
                                    options={options}
                                />
                            </div>
                        </div>
                </div>

                <div className={s.tab}>
                    <Tab
                        onChange={this.onTabSelection.bind(this)}
                        active={this.props.activeView}
                        tabs={{
                            chatList: {
                                name: "Conversas",
                                body: <ChatList/>
                            },
                            contactList: {
                                name: "Contatos",
                                body: <ContactList/>
                            }
                        }}
                    />
                </div>

                {this.props.isInvitePatientDialogOpen ?
                    <InviteUserDialog
                        onSubmit={this.invitePatient.bind(this)}
                        onCloseDialog={this.closeInvitePatientDialog.bind(this)}
                        doctor={false}
                    />
                : null}

                {this.props.isInviteDoctorDialogOpen ?
                    <InviteUserDialog
                        onSubmit={this.inviteDoctor.bind(this)}
                        onCloseDialog={this.closeInviteDoctorDialog.bind(this)}
                        doctor={true}
                    />
                : null}

                {this.props.isCreateGroupDialogOpen ?
                    <CreateGroupDialog
                        onSubmit={this.createGroup.bind(this)}
                        onCloseDialog={this.closeCreateGroupDialog.bind(this)}
                        contacts={this.state.doctors}
                    />
                : null}
            </div>
        );
    }
}

export default connect((state: RootState) => ({
    user: state.auth.user,
    activeView: state.ui.sidebar.view,
    isInvitePatientDialogOpen: state.ui.dialogs.invitePatient,
    isInviteDoctorDialogOpen: state.ui.dialogs.inviteDoctor,
    isCreateGroupDialogOpen: state.ui.dialogs.createGroup,
    contacts: state.entities.contacts.allIds.map(userId => {
        return state.entities.users.byId[userId];
    })
}))(SidebarMain);



// WEBPACK FOOTER //
// ./src/containers/Sidebar/Main/index.tsx